export const environments = JSON.parse(process.env.REACT_APP_ENV!);

export default function getEnvironment(name: string = 'de') {
  const env = environments[name];
  if (!name || !env) {
    throw new Error('Invalid env.');
  }
  return { ...env, name };
}



// WEBPACK FOOTER //
// ./src/lib/getEnvironment.ts